import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import Multiselect from '../CreateModal/components/Multiselect'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { Button, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'

const EditModal = ({ data, handleRefresh, awards, questions, category }) => {
  console.log(data, 'datadata')
  const { chapter_id, type } = useParams()

  const AppService = useAppServices()
  const uploadImage = useUploadImage()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [svgIcon, setSvgIcon] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)

  const awardsOptions = awards?.map((item) => ({
    label: item?.name,
    value: item?._id,
  }))
  const questionsOptions = questions?.map((item) => ({
    label: item?.question,
    value: item?._id,
  }))

  const handleModal = () => {
    setOpenEditProduct(true)
  }
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0])
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0])
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const formData = new FormData(e.target)
    const answerValue = formData.get('answer') === 'true'
    let image_response = null
    if (selectedFile) {
      image_response = await uploadImage({
        file: selectedFile,
        desiredPath: `app/logo/image`,
      })
    }
    const payload = {
      _id: data._id,
      chapter_id: type,
      question: e.target.question.value,
      answer: answerValue,
      priority: e.target.priority.value,
      points: e.target.points.value,
      image: image_response?.response.data || data?.image || '',
      type: chapter_id,
      status: e.target.status.value,
    }

    const { response } = await AppService.questions_chapters.update({ payload })

    if (response) {
      setProcessing(false)
      // closeAddProduct();
      setOpenEditProduct(false)

      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Question Chapters
            </MDTypography>

            {/* <MDBox mb={2}>
              <MDTypography variant="button">Category</MDTypography>
              <MDInput
                select
                name="chapter_id"
                fullWidth
                required
                defaultValue={data?.chapter_id?._id}
                SelectProps={{ native: true }}
              >
                <option value="">Select a chapter</option>
                {category.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.chapter_name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Question</MDTypography>
              <MDInput
                label="Question"
                name="question"
                fullWidth
                required
                defaultValue={data?.question}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Answer</MDTypography>
              <FormControl fullWidth>
                <InputLabel>Answer</InputLabel>
                <Select name="answer" defaultValue={data?.answer}>
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput
                label="Point Number"
                name="points"
                fullWidth
                required
                defaultValue={data?.points}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">priority</MDTypography>
              <MDInput
                label="priority"
                name="priority"
                fullWidth
                required
                defaultValue={data?.priority}
              />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                defaultValue={data.type}
                SelectProps={{ native: true }}
              >
                <option value="User">User</option>
                <option value="Location">Location</option>
                <option value="Agency">Agency</option>
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}
                defaultValue={data?.status}>
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" onChange={handleFileChange} />
              </Button>
            </Stack>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
